import { AccessDeniedPage } from "@climatepartner/components/ErrorPages";
import { ReactElement, useContext } from "react";

import { UserContext } from "../user-context";

export type ModuleGuardProps = {
  children: ReactElement | ReactElement[];
};

type AuthGuardProps = ModuleGuardProps & {
  hasAccess: boolean;
};

/**
 * `hasAccess` is a decided boolean, never the hook that decides it: CCF and PCF are sibling routes
 * under `/customer/:customerId`, so React reuses this component's fiber when navigating between the
 * two modules, and a hook called through a prop would change hook order mid-fiber. Each module calls
 * its own hook in its own guard component, whose distinct type also makes React remount rather than
 * carry state across the modules.
 */
export const ApplicationAuthorisationGuard = ({ hasAccess, children }: AuthGuardProps): ReactElement => {
  const { user } = useContext(UserContext);

  if (!user?.isAuthenticated || !hasAccess) {
    return <AccessDeniedPage />;
  }

  return <>{children}</>;
};
